import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'cva-global-http-loader',
    templateUrl: './global-http-loader.component.html',
    styleUrl: './global-http-loader.component.scss',
    
})
export class GlobalHttpLoaderComponent {}
